var chunkMapping = {
	"webpack_container_remote_helpdeskUi_HelpdeskModule": [
		42404
	],
	"webpack_container_remote_coreUi_PremiseModule": [
		56257
	],
	"webpack_container_remote_coreUi_BuildingModule": [
		26445
	],
	"webpack_container_remote_coreUi_CompanyModule": [
		21122
	],
	"webpack_container_remote_coreUi_UsersModule": [
		83924
	],
	"webpack_container_remote_helpdeskUi_StoreModule": [
		12348
	],
	"webpack_container_remote_eoaUi_EventModule": [
		56051
	],
	"webpack_container_remote_eoaUi_AnnouncementModule": [
		30376
	],
	"webpack_container_remote_eoaUi_OfferModule": [
		41962
	],
	"webpack_container_remote_vmsUi_VisitorModule": [
		54164
	],
	"webpack_container_remote_cafeUi_CafeModule": [
		11234
	],
	"webpack_container_remote_transportUi_Module": [
		20368
	],
	"webpack_container_remote_spaceUi_SpaceModule": [
		99579
	],
	"webpack_container_remote_rosterUi_Module": [
		3664
	],
	"webpack_container_remote_spaceUi_SpacePaymentModule": [
		73548
	]
};
var idToExternalAndNameMapping = {
	"3664": [
		"default",
		"./Module",
		86776
	],
	"11234": [
		"default",
		"./CafeModule",
		47398
	],
	"12348": [
		"default",
		"./StoreModule",
		45156
	],
	"20368": [
		"default",
		"./Module",
		69340
	],
	"21122": [
		"default",
		"./CompanyModule",
		25802
	],
	"26445": [
		"default",
		"./BuildingModule",
		25802
	],
	"30376": [
		"default",
		"./AnnouncementModule",
		51438
	],
	"41962": [
		"default",
		"./OfferModule",
		51438
	],
	"42404": [
		"default",
		"./HelpdeskModule",
		45156
	],
	"54164": [
		"default",
		"./VisitorModule",
		27199
	],
	"56051": [
		"default",
		"./EventModule",
		51438
	],
	"56257": [
		"default",
		"./PremiseModule",
		25802
	],
	"73548": [
		"default",
		"./SpacePaymentModule",
		24589
	],
	"83924": [
		"default",
		"./UsersModule",
		25802
	],
	"99579": [
		"default",
		"./SpaceModule",
		24589
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}